import getSelectedTicketTypes from './getSelectedTicketTypes';

// Builds the `ticketPwywAmounts` request field: resolved minor amounts
// keyed by ticket type id, for selected pay-what-you-want tickets only.
export default function getTicketPwywAmountValues(
  checkoutTicketGroups,
  formTicketGroups,
  currency,
) {
  const selectedTicketTypes = getSelectedTicketTypes(
    checkoutTicketGroups,
    formTicketGroups,
    currency,
  );

  return selectedTicketTypes.reduce((obj, ticketType) => {
    if (ticketType.pricing === 'pwyw') {
      obj[ticketType._id] = ticketType.price;
    }

    return obj;
  }, {});
}
